import { render } from "./ScrollPagination.vue?vue&type=template&id=cb0248ec&ts=true"
import script from "./ScrollPagination.vue?vue&type=script&lang=ts"
export * from "./ScrollPagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__